import React, { useState } from "react";

import {
  Grid,
  Typography,
  Box,
  IconButton,
  Button,
  Modal,
  TextField,
} from "@mui/material";

import { InputDropZone } from "./DropZone";

import classes from "./Section.module.css";

import CustomizeInputField from "./CustomizeInputField";

import SettingsIcon from "@mui/icons-material/Settings";

import { useDrag } from "react-dnd";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const Section = ({
  layout,
  sectionPath,
  handleDrop,
  handleRemoveItem,
  handleEdit,
  handleDeleteSection,
  handleEditSectionName,
  handleIsHiddenItem,
}) => {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [closeModalOpen, setCloseModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [{ opacity }, drag] = useDrag({
    type: "section",
    item: layout,
    collect: (monitor) => ({
      opacity: monitor.isDragging() ? 0.4 : 1,
    }),
  });
console.log(layout,"layouthh")
  console.log(layout, "layout " + sectionPath);
  const handleOpenMenu = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const deleteHandler = () => {
    // handleDeleteSection(layout.id);
    // handleClose();
    setCloseModalOpen(true);
  };

  return (
    <div
      className={classes.section}
      ref={drag}
      style={{
        opacity,
        border: layout.isMandetory ? "1px solid black" : "1px dashed black",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h5" align="left">
          {layout.layoutName}
        </Typography>
        {!layout.isMandetory && (
          <IconButton onClick={handleOpenMenu}>
            <SettingsIcon />
          </IconButton>
        )}
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={() => setEditDialogOpen(true)}>
            Edit Section
          </MenuItem>
          <MenuItem
            onClick={deleteHandler}
            sx={{
              color: "red",
            }}
          >
            Delete
          </MenuItem>
        </Menu>
      </Box>
      <Grid container spacing={2}>
        <Grid xs={6} item>
          {layout?.children?.column1?.map((child, index) => {
            const columnPath = index;
            return (
              <React.Fragment key={index}>
                <InputDropZone
                  data={{
                    columnPath: columnPath,
                    sectionPath: sectionPath,
                    columnKey: "column1",
                  }}
                  handleDrop={handleDrop}
                />
                <CustomizeInputField
                  {...child}
                  handleRemoveItem={handleRemoveItem}
                  handleEdit={handleEdit}
                  data={{
                    columnPath: columnPath,
                    sectionPath: sectionPath,
                    columnKey: "column1",
                  }}
                  handleIsHiddenItem={handleIsHiddenItem}
                />
              </React.Fragment>
            );
          })}
          <InputDropZone
            data={{
              columnPath: layout?.children?.column1?.length,
              sectionPath: sectionPath,
              columnKey: "column1",
            }}
            handleDrop={handleDrop}
          />
        </Grid>
        <Grid xs={6} item>
          {layout?.children?.column2?.map((child, index) => {
            const columnPath = index;
            return (
              <React.Fragment key={index}>
                <InputDropZone
                  data={{
                    columnPath: columnPath,
                    sectionPath: sectionPath,
                    columnKey: "column2",
                  }}
                  handleDrop={handleDrop}
                />
                <CustomizeInputField
                  {...child}
                  data={{
                    columnPath: columnPath,
                    sectionPath: sectionPath,
                    columnKey: "column2",
                  }}
                  handleRemoveItem={handleRemoveItem}
                  handleEdit={handleEdit}
                  handleIsHiddenItem={handleIsHiddenItem}
                />
              </React.Fragment>
            );
          })}
          <InputDropZone
            data={{
              columnPath: layout?.children?.column2?.length,
              sectionPath: sectionPath,
              columnKey: "column2",
            }}
            handleDrop={handleDrop}
          />
        </Grid>
      </Grid>
      <CloseModal
        open={closeModalOpen}
        setOpen={setCloseModalOpen}
        handleRemoveSection={handleDeleteSection}
        sectionName={layout.layoutName}
        handleClose={handleClose}
        sectionId={layout.id}
      />
      <EditDialog
        handleEditSectionName={handleEditSectionName}
        id={layout.id}
        open={editDialogOpen}
        layoutName={layout.layoutName}
        setOpen={setEditDialogOpen}
      />
    </div>
  );
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function CloseModal({
  open,
  setOpen,
  handleRemoveSection,
  sectionId,
  handleClose,
  sectionName,
}) {
  // const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h5" component="h2">
          Delete {sectionName}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }} variant="h6">
          Are you Sure You Want To Delete It?
        </Typography>
        <Box
          sx={{
            marginTop: "1rem",
            ".MuiButton-root": {
              margin: "0 8px",
            },
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              setOpen(false);
              handleRemoveSection(sectionId);
              handleClose();
            }}
            sx={{
              background: "crimson",
              "&:hover": {
                background: "red",
              },
            }}
          >
            Yes, Delete The Section
          </Button>
          <Button variant="contained" onClick={() => setOpen(false)}>
            No
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

function EditDialog({ handleEditSectionName, open, setOpen, id, layoutName }) {
  const [input, setInput] = useState(layoutName);
  const handleClose = () => {
    setOpen(false);
  };

  const editHandler = () => {
    handleEditSectionName(id, input);
    handleClose();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        id="responsive-dialog-title"
        sx={{
          width: "90vw",
          maxWidth: "340px",
        }}
      >
        Edit Layout Name
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Layout Name
        </DialogContentText>
        <TextField
          size="small"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button
          // autoFocus
          onClick={handleClose}
          variant="contained"
          sx={{
            backgroundColor: "crimson",
            "&:hover": {
              backgroundColor: "red",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={editHandler}
          // autoFocus
          variant="contained"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default Section;
